import { CardMedia as MuiCardMedia, Grid, Grid as MuiGrid } from "@mui/material";
import { useIntl } from "react-intl";

import { formatItem } from "@framework/exchange";
import { IAssetPromo } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { PromoPurchaseButton } from "../../../../../../components/buttons";

interface IAssetPromoItemProps {
  promo: IAssetPromo;
}

export const AssetPromoItem = (props: IAssetPromoItemProps) => {
  const { promo } = props;

  const { formatMessage } = useIntl();

  return (
    <Card
      variant="outlined"
      header={
        <Card.Header
          title={<MuiCardMedia image={promo.item?.components[0]?.template?.imageUrl} />}
          subheader={
            <Typography variant="h5" color="textPrimary">
              {promo.item?.components[0]?.template?.title}
            </Typography>
          }
        />
      }
    >
      <Card.Content>
        <Grid container size={12} mb={1}>
          <Grid size={4}>
            <Typography
              variant="body1"
              fontWeight={700}
            >{`${formatMessage({ id: "pages.marketplace.templates.price" })}:`}</Typography>
          </Grid>
          <Grid size={8}>
            <Typography variant="body2" color="textSecondary" component="p">
              {formatItem(promo.price)}
            </Typography>
          </Grid>
        </Grid>
      </Card.Content>

      <Card.Footer>
        <MuiGrid container alignItems="center">
          <PromoPurchaseButton promo={promo} />
        </MuiGrid>
      </Card.Footer>
    </Card>
  );
};
